import {datadogLogs} from '@datadog/browser-logs';
import {datadogRum} from '@datadog/browser-rum';

import {clientCookieUtils} from '@/utils/portalCookies';

import {addToDataLayer} from '../../../utils/pageUtils';

/**
 * Returns the localStorage object if available, or undefined if not.
 *
 * @description Fix for Chrome incognito (with "Block third-party cookies" enabled) and Safari private mode.
 * @error Uncaught SecurityError: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
 *
 * @returns The localStorage object or undefined.
 */
export const getLocalStorage = (): Storage | undefined => {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
};

/**
 * Reports a rendering error to Datadog (RUM + Logs) and the GTM dataLayer.
 * Async because it needs to read the portal user cookie before tagging.
 */
export const reportRenderingError = async (
  error: Error,
  renderingError: Error,
): Promise<void> => {
  datadogRum.addError(renderingError, {
    tags: ['_app-capture-exception'],
  });
  datadogLogs.logger.error(
    renderingError.message,
    {tags: ['_app-capture-exception']},
    error,
  );

  const portalUser = await clientCookieUtils.get();
  const user = portalUser
    ? {
        identifier: portalUser.userId,
        role: 'prospect',
      }
    : null;

  addToDataLayer({
    overrideBase: 'renderingError',
    values: {
      User_Id: user?.identifier,
      User_Role: user?.role,
    },
  });
  datadogRum.addAction('renderingError', {
    User_Id: user?.identifier,
    User_Role: user?.role,
  });
};
